<div style="height:calc(100vh - 235px);">
    <dx-data-grid #apiKeysGrid
                  height="100%"
                  hoverStateEnabled="true"
                  [dataSource]="dataSource"
                  [errorRowEnabled]="false"
                  [wordWrapEnabled]="true">
        <dxo-editing mode="row" [allowAdding]="false" [allowDeleting]="true" [allowUpdating]="true" [useIcons]="true" />
        <dxo-header-filter [visible]="true" />
        <dxo-paging [enabled]="false" />
        <dxo-search-panel [visible]="true" [width]="250" [placeholder]="'_commons.search' | translate" />
        <dxo-summary>
            <dxi-total-item column="description" [displayFormat]="'apiKeys.lblApiKeysCount' | translate" summaryType="count"/>
        </dxo-summary>
        <dxo-toolbar>
            <dxi-item location="after">
                <div *dxTemplate>
                    <dx-button icon="add" [text]="'_commons.add' | translate" (onClick)="onAddButtonClick($event)" />
                </div>
            </dxi-item>
            <dxi-item location="after">
                <div *dxTemplate>
                    <dx-button icon="refresh" [text]="'_commons.refresh' | translate" (onClick)="onRefreshButtonClick()" />
                </div>
            </dxi-item>
            <dxi-item name="searchPanel" />
        </dxo-toolbar>

        <dxi-column dataField="description" [caption]="'apiKeys.lblDescription' | translate" />
        <dxi-column type="buttons" [width]="130">
            <dxi-button icon="copy"
                        [hint]="'_commons.copy' | translate"
                        [onClick]="onCopyApiKeyClick"
                        [visible]="isCopyIconVisible"/>
            <dxi-button icon="pulldown"
                        [hint]="'_clipboard.reset' | translate"
                        [onClick]="onResetApiKeyClick"
                        [visible]="isResetIconVisible"/>
            <dxi-button name="edit"/>
            <dxi-button name="delete"/>
        </dxi-column>
    </dx-data-grid>
</div>